export default __webpack_public_path__ + "static/media/price-five-bg.5aecb0fb.png";